<template>
  <div class="card partner-card">
    <div class="card-body partner-card__body">
      <!-- Toggle Switch ve Info Alanı -->
      <div v-if="showStatusToggle" class="partner-card__status">
        <label class="uk-switch uk-switch-small">
          <input :checked="partner.status === 1"
                 :disabled="isUpdatingStatus"
                 type="checkbox"
                 @change="handleStatusChange"
          />
          <span class="uk-switch-slider"></span>
        </label>

        <span class="status-label">
          {{ partner.status === 1 ? $t('general.active') : $t('general.passive') }}
        </span>

        <i :uk-tooltip="`title: Partner'in son kullanıcılara gösterilip gösterilmeyeceğini kontrol eder. Aktif durumda partner son kullanıcılara gösterilir, pasif durumda gösterilmez.; pos: bottom`"
           class="uil-info-circle status-info-icon"
        ></i>
      </div>

      <div class="partner-card__layout">
        <div class="partner-card__logo-wrap">
          <div class="partner-card__logo">
            <img :alt="partner.name" :src="partner.image_url" loading="lazy"/>
          </div>
        </div>

        <div class="partner-card__content">
          <div class="partner-card__main">
            <h5 class="partner-card__name">{{ partner.name }}</h5>

            <p v-if="partner.info" class="partner-card__info">
              {{ partner.info }}
            </p>
          </div>

          <div class="partner-card__footer">
            <a :href="partner.connect_url || partner.default_url"
               class="partner-card__action-btn"
               target="_blank"
               @click.prevent="handleConnection">
              <i class="uil-external-link-alt"></i>
              {{ $t('general.connection') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PartnerCard",
  props: {
    partner: {
      type: Object,
      required: true
    },
    showStatusToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isUpdatingStatus: false
    };
  },
  methods: {
    handleConnection() {
      this.$emit('connect', this.partner);
    },
    async handleStatusChange(event) {
      const newStatus = event.target.checked ? 1 : 0;
      this.isUpdatingStatus = true;

      try {
        const response = await axios.post(`api/partners/${this.partner.id}/status`,
            { status: newStatus }
        );

        const updatedPartner = response.data?.data || response.data;
        this.$emit('status-changed', { partner: updatedPartner });
      } catch (error) {
        console.error('Status güncellenirken hata oluştu:', error);
        this.$emit('status-error', { partner: this.partner, error });
        event.target.checked = !event.target.checked;
      } finally {
        this.isUpdatingStatus = false;
      }
    }
  }
};
</script>

<style scoped>
.partner-card {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  background: #fff;
  box-shadow: none !important;
  margin-bottom: 0;
}

.partner-card__body {
  position: relative;
  padding: 24px;
}

.partner-card__layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.partner-card__logo-wrap {
  flex-shrink: 0;
  width: 200px;
}

.partner-card__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  min-height: 100px;
}

.partner-card__logo img {
  width: 100%;
  max-width: 160px;
  max-height: 120px;
  object-fit: contain;
}

.partner-card__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
}

.partner-card__main {
  flex: 1;
}

.partner-card__name {
  margin: 0 0 8px 0;
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

.partner-card__info {
  margin: 0;
  color: #64748b;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.partner-card__footer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.partner-card__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  padding: 0 24px;
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  background: var(--backgroundColor, #6366f1);
  color: #fff;
  border: none;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.partner-card__action-btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.partner-card__action-btn i {
  font-size: 16px;
}

.partner-card__status {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.status-info-icon {
  color: #64748b;
  cursor: help;
  font-size: 14px;
  transition: color 0.2s ease;
}

.uk-switch {
  height: 24px;
  width: 50px;
}

.uk-switch-slider:before {
  width: 20px;
  height: 20px;
}

.uk-switch input:disabled + .uk-switch-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.uk-switch input:disabled {
  cursor: not-allowed;
}

/* Tablet */
@media (max-width: 768px) {
  .partner-card__layout {
    flex-direction: column;
    gap: 16px;
  }

  .partner-card__logo-wrap {
    width: 100%;
  }

  .partner-card__logo {
    padding: 16px;
    min-height: 80px;
  }

  .partner-card__logo img {
    max-width: 140px;
    max-height: 80px;
  }

  .partner-card__body {
    padding: 16px;
  }

  .partner-card__name {
    font-size: 16px;
  }

  .partner-card__status {
    top: 12px;
    right: 12px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .partner-card__body {
    padding: 16px;
  }

  .partner-card__logo {
    padding: 12px;
    min-height: 70px;
    border-radius: 10px;
  }

  .partner-card__logo img {
    max-width: 120px;
    max-height: 60px;
  }

  .partner-card__name {
    font-size: 16px;
    margin-bottom: 4px;
  }

  .partner-card__info {
    -webkit-line-clamp: 2;
  }

  .partner-card__footer {
    margin-top: 12px;
    padding-top: 12px;
  }

  .partner-card__action-btn {
    width: 100%;
    height: 48px;
    border-radius: 10px;
    font-size: 14px;
  }

  .partner-card__status {
    gap: 6px;
  }
}

@media (max-width: 639px) {
  .partner-card {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    border-radius: 12px !important;
  }

  .partner-card__body {
    padding: 12px;
  }

  .partner-card__layout {
    gap: 12px;
  }

  .partner-card__logo {
    min-height: 88px;
    padding: 12px;
    border-radius: 10px;
  }

  .partner-card__logo img {
    max-width: 140px;
    max-height: 72px;
  }

  .partner-card__name {
    font-size: 16px;
    line-height: 1.4;
  }

  .partner-card__info {
    font-size: 14px;
    line-height: 1.5;
  }

  .partner-card__action-btn {
    min-height: 48px;
    height: auto;
    padding: 12px 16px;
    box-sizing: border-box;
  }
}
</style>
